import type { GenericServiceParameters } from "~/core/models/GenericServiceParameters.interface";
import LxcError from "~/core/models/LxcError.class";
import type { Fleet } from "~/modules/fleet/models/Fleet.interface";
import fleetService from "~/modules/fleet/services/fleet.service";

export function useGetFleet({
  organizationCode,
}: GenericServiceParameters<void>) {
  const result = ref<Fleet>();
  const isLoading = ref(false);
  const error = ref<LxcError | null>(null);

  async function getFleet(uid: string): Promise<void> {
    isLoading.value = true;

    const response = await fleetService.getOrganizationFleet({
      organizationCode,
      uid,
    });

    if (LxcError.check(response)) {
      error.value = response;
      result.value = undefined;
    } else {
      error.value = null;
      result.value = response;
    }

    isLoading.value = false;
  }

  return {
    getFleet,
    result,
    error,
    isLoading,
  };
}
